<div class="container modal-dialog-centered">
  <div class="modal-content">


    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        {{ ('notes.modalTitle' | cxTranslate) }}
      </div>
      <button
        type="button"
        class="close"
        attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}"
        (click)="dismissModal('Cross click')"
        >
        <span aria-hidden="true">
          <cx-icon [type]="eIconTypes.CLOSE"></cx-icon>
        </span>
      </button>
    </div>

    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row">
        <section class="cx-dialog-item col-12">

          @if (isLoading$ | async) {
            <div>
              <div class="cx-spinner">
                <cx-spinner> </cx-spinner>
              </div>
            </div>
          } @else {
            <form (ngSubmit)="onSubmit()">
              <div class="form-group">
                <label for="notesEdit" class="cart-notes-dialog__section-title">
                  {{ ('notes.edit' | cxTranslate) }}
                </label>
                <textarea
                  class="form-control cart-notes-dialog__textarea"
                  id="notesEdit"
                  rows="3"
                  maxlength="300"
                  name="note"
                [(ngModel)]="note"></textarea>
                <div class="row">
                  <div class="col-6"></div>
                  <div class="col-6">
                    <button class="btn btn-secondary btn-block cart-notes-dialog__submit-cta" type="submit">
                      {{ 'notes.save' | cxTranslate }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          }

        </section>
      </div>
    </div>
  </div>
</div>
